import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAuthContext from '../../providers/authProvider';

const ForgotPassword = () => {
  const { forgotPassword } = useAuthContext();

  const { t } = useTranslation();

  const [sent, setSent] = useState(false);

  const submit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const email = formData.get('email');

    forgotPassword({ email });
    setSent(true);
  }

  return (
    <div className='unauthorized-container'>
      <div className="login-page">
        <div className="login-page-logo">
          <img src="/images/logo.png"/>
            <div>Supercoach</div>
        </div>
        <div className="login-page-title">{t('signIn.forgot')}</div>

        <div className="login-page-form">
          { sent
          ? <div>
              <h4>{t('signIn.reset_password_sent')}</h4>
              <div className="actions">
                <Link to="/club_admin/login">{t('signIn.log_in')}</Link>
              </div>  
            </div>
          : <form className="new_club_admin" onSubmit={submit}>
              <div className="form-group form-group-lg">
                <label htmlFor="club_admin_email">{t('common.table_email')}</label><br/>
                <input autoFocus="autofocus" className="form-control" type="email" name="email"/>
              </div>

              <div className="actions">
                <button type="submit" name="commit" className="btn btn-success btn-lg">{t('signIn.reset_password')}</button>
                <Link to="/club_admin/login">
                  {t('signIn.log_in')}
                </Link>
                <br/>
              </div>
            </form>
          }
          
        </div>
      </div>
    </div>

  )
};

export default ForgotPassword;
